import { isScrollBottom } from "@/utils";
import util from "./util";
export const logMixins = {
  data() {
    return {
      height: 0,
      loadItems: [],
      menu: false,
      options: {},
      loading: false,
      isLastPage: false,
      defaultPageSize: 50,
      downloadPageSize: 15000
    };
  },

  computed: {
    rowsCount() {
      return this.loadItems.length !== 0 && !this.isLastPage
        ? this.loadItems.length + "+"
        : this.loadItems.length;
    }
  },

  created() {
    this.initialize();
  },
  beforeDestroy() {
    document
      .querySelector(".v-data-table__wrapper")
      .removeEventListener("scroll", this.scroll);
  },
  mounted() {
    let el = document.querySelector(".v-data-table__wrapper");
    el.addEventListener("scroll", this.scroll);
    this.computeHeight();
  },

  methods: {
    scroll({ target: { scrollTop, clientHeight, scrollHeight } }) {
      if (
        !this.isLastPage &&
        !this.loading &&
        isScrollBottom(scrollTop, clientHeight, scrollHeight)
      ) {
        this.paginate();
      }
    },

    computeHeight() {
      let el = this.$refs.dataContainer.$el;
      let boxOffset = el.getBoundingClientRect();
      let viewPortHeight = window.innerHeight;
      this.height = viewPortHeight - boxOffset.top;
    },

    paginate() {
      this.initialize();
    },

    refresh() {
      this.paginateParams.object_id = 0;
      this.loadItems = [];
      this.initialize();
    },

    removeComma(unFormattedString) {
      // remove commas to avoid errors
      return unFormattedString.replace(/,/g, " ");
    },

    exportCSVFile(headers, items, fileTitle) {
      if (headers) {
        items.unshift(headers);
      }

      // Convert Object to JSON
      let jsonObject = JSON.stringify(items);

      let csv = this.convertToCSV(jsonObject);

      let exportedFilename = fileTitle + ".csv" || "export.csv";

      let blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        // IE 10+
        navigator.msSaveBlob(blob, exportedFilename);
      } else {
        let link = document.createElement("a");
        if (link.download !== undefined) {
          // feature detection
          // Browsers that support HTML5 download attribute
          let url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", exportedFilename);
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    },

    convertToCSV(objArray) {
      let array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
      let str = "";

      for (let i = 0; i < array.length; i++) {
        let line = "";
        for (let index in array[i]) {
          if (line !== "") line += ",";

          line += array[i][index];
        }

        str += line + "\r\n";
      }

      return str;
    },
    parseLogDatetime: util.parseLogDatetime
  }
};
